module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0095.jpg?v=f9299f62";